import React, { KeyboardEventHandler, useEffect, useState } from 'react';
import { filterUnpredictableUtf8Characters } from 'ff-filter-characters';
import { preventMobileAutoScroll } from '../helpers/preventMobileAutoScroll';
import styles from '../Input.module.scss';

export const TextInputField = ({
    preventAutoScroll = true,
    commit, maxLength = 13, ...props
}: Props) => {

    const [localValue, setLocalValue] = useState<string | null>(null);

    const reset = () => setLocalValue(props.value);
    useEffect(reset, [props.value]);

    const onKeyDown: KeyboardEventHandler<HTMLInputElement> = e => {
        if (e.key === 'Enter') {
            e.currentTarget.blur();
            props.enter && props.enter();
        }
    };

    const onInput = (input: string) => {
        setLocalValue(input);
        commit(input);
    };

    const onFocus = () => {
        preventAutoScroll && preventMobileAutoScroll();
    };

    const onBlur = () => {
        reset();
    };

    const value = localValue !== null ? localValue : props.value;

    return (
        <label className={styles.default}>
            <input type='text'
                {...props}
                className={styles.input}
                onKeyDown={onKeyDown} onFocus={onFocus} onBlur={onBlur}
                onChange={e => onInput(filterUnpredictableUtf8Characters(e.currentTarget.value))}
                value={value} maxLength={maxLength}
                name={props.label} id={props.label} />
            <p className={styles.feedback}>{value.length}/{maxLength}</p>
        </label>
    );
};
type Props = {
    value: string;
    label?: string;
    commit: (value: string) => void;
    enter?: () => void;
    placeholder?: string;
    length?: number;
    maxLength?: number;
    preventAutoScroll?: boolean;
};